var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 1000,
    height: 1000,
    viewBox: "0 0 1000 1000",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-_1000x1000"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1000,
    height: 1000
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_1000x1000",
    "data-name": "1000x1000",
    clipPath: "url(#clip-_1000x1000)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1000,
    height: 1000,
    fill: "rgba(255,255,255,0)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_1",
    "data-name": "Ellipse 1",
    transform: "translate(427 301)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 4
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 73,
    cy: 199.5,
    rx: 73,
    ry: 199.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 73,
    cy: 199.5,
    rx: 71,
    ry: 197.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_2",
    "data-name": "Ellipse 2",
    transform: "translate(427 301)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 4
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 73,
    cy: 199.5,
    rx: 73,
    ry: 199.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 73,
    cy: 199.5,
    rx: 71,
    ry: 197.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_3",
    "data-name": "Ellipse 3",
    transform: "matrix(0.809, -0.588, 0.588, 0.809, 323.679, 382.009)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 4
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 73,
    cy: 199.5,
    rx: 73,
    ry: 199.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 73,
    cy: 199.5,
    rx: 71,
    ry: 197.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_4",
    "data-name": "Ellipse 4",
    transform: "matrix(0.309, -0.951, 0.951, 0.309, 287.706, 508.278)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 4
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 73,
    cy: 199.5,
    rx: 73,
    ry: 199.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 73,
    cy: 199.5,
    rx: 71,
    ry: 197.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_5",
    "data-name": "Ellipse 5",
    transform: "matrix(-0.309, -0.951, 0.951, -0.309, 332.822, 631.576)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 4
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 73,
    cy: 199.5,
    rx: 73,
    ry: 199.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 73,
    cy: 199.5,
    rx: 71,
    ry: 197.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_6",
    "data-name": "Ellipse 6",
    transform: "matrix(-0.809, -0.588, 0.588, -0.809, 441.795, 704.807)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 4
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 73,
    cy: 199.5,
    rx: 73,
    ry: 199.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 73,
    cy: 199.5,
    rx: 71,
    ry: 197.5,
    fill: "none"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.82cf69b66834109d12b67718a011f84e.svg";
export { ForwardRef as ReactComponent };